import React, { useState, useRef, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import Icon from '../AppIcon';
import Button from './Button';

const QuickActionMenu = () => {
  const [isOpen, setIsOpen] = useState(false);
  const menuRef = useRef(null);
  const navigate = useNavigate();
  const location = useLocation();

  const quickActions = [
    {
      label: 'Calculate Route Toll',
      icon: 'Calculator',
      action: () => navigate('/toll-calculator'),
      description: 'Optimize your route costs',
      show: location?.pathname === '/nordic-map-dashboard'
    },
    {
      label: 'View Live Traffic',
      icon: 'Map',
      action: () => navigate('/nordic-map-dashboard'),
      description: 'Check real-time conditions',
      show: location?.pathname === '/toll-calculator'
    },
    {
      label: 'Manage Subscription',
      icon: 'User',
      action: () => navigate('/nord-pass-subscription-portal'),
      description: 'Update your account',
      show: location?.pathname !== '/nord-pass-subscription-portal'
    }
  ];

  const visibleActions = quickActions?.filter(action => action?.show);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef?.current && !menuRef?.current?.contains(event?.target)) {
        setIsOpen(false);
      }
    };

    const handleEscape = (event) => {
      if (event?.key === 'Escape') {
        setIsOpen(false);
      }
    };

    if (isOpen) {
      document.addEventListener('mousedown', handleClickOutside);
      document.addEventListener('keydown', handleEscape);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
      document.removeEventListener('keydown', handleEscape);
    };
  }, [isOpen]);

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  const handleAction = (action) => {
    action();
    setIsOpen(false);
  };

  if (visibleActions?.length === 0) return null;

  return (
    <div className="fixed bottom-24 right-24 z-dropdown" ref={menuRef}>
      <div className="relative">
        {isOpen && (
          <div className="absolute bottom-full right-0 mb-12 w-80 bg-card border border-border rounded-lg glow-md overflow-hidden">
            <div className="p-12 border-b border-border">
              <h3 className="text-base font-medium text-foreground">Quick Actions</h3>
            </div>
            <div className="p-6">
              {visibleActions?.map((action, index) => (
                <button
                  key={index}
                  onClick={() => handleAction(action?.action)}
                  className="w-full flex items-start space-x-12 p-12 rounded-md text-left transition-smooth hover:bg-muted/50 group"
                >
                  <div className="flex-shrink-0 w-40 h-40 flex items-center justify-center bg-primary/10 rounded-md group-hover:bg-primary/20 transition-smooth">
                    <Icon name={action?.icon} size={20} color="var(--color-primary)" />
                  </div>
                  <div className="flex-1 min-w-0">
                    <div className="text-sm font-medium text-foreground group-hover:text-primary transition-smooth">
                      {action?.label}
                    </div>
                    <div className="text-caption text-muted-foreground mt-2">
                      {action?.description}
                    </div>
                  </div>
                </button>
              ))}
            </div>
          </div>
        )}

        <Button
          variant="default"
          size="lg"
          onClick={toggleMenu}
          className="rounded-full w-56 h-56 p-0 glow-md hover:glow-lg shadow-lg"
          iconName={isOpen ? 'X' : 'Zap'}
          iconSize={24}
          aria-label="Quick actions menu"
          aria-expanded={isOpen}
        />
      </div>
    </div>
  );
};

export default QuickActionMenu;